/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {formatDate} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {FabMessageService} from '@fabric/components/message';
import {ColDef} from 'ag-grid-community';
import {DISMISS_MSG} from '../../../common/constants';
import {getDefaultYearRange} from '../../../core/helpers/generic-helpers';
import {StateService} from '../../../core/state/state.service';
import {ExcelExportService} from '../../../services/excel-export.service';
import {GlobalScenarioService} from '../../../services/global-scenario-service';

@Component({
    selector: 'app-global-vehicle-forecast-template',
    templateUrl: './global-vehicle-forecast-template.component.html',
    styleUrl: './global-vehicle-forecast-template.component.scss',
    standalone: false
})
export class GlobalVehicleForecastTemplateComponent implements OnInit {
  showSpinner: boolean;
  selectedGlobalScenario: any = undefined;
  startYear: number;
  endYear: number;
  yearRange: number[] = [];
  displayedMemberHeaders: ColDef[] = [
    {field: 'vehScenId', headerName: 'Vehicle Scenario ID', lockPosition: true},
    {field: 'vehScenName', headerName: 'Vehicle Scenario Name', lockPosition: true},
    {field: 'fcorg', headerName: 'FCORG', lockPosition: true},
  ];

  constructor(readonly stateService: StateService,
              readonly globalScenarioService: GlobalScenarioService,
              readonly excelExportService: ExcelExportService,
              public dialog: MatDialog,
              public snackBar: FabMessageService) {

  }

  ngOnInit() {
    this.getYearRange();
  }

  /**
   * Export the report containing vehicle records for a Global Scenario
   */
  exportReport(): void {
    this.showSpinner = true;
    const currDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    const fileName = 'GlblVehFT_' + this.selectedGlobalScenario.globalScenarioName + '_' + currDate;
    this.globalScenarioService.globalVehicleForecastTemplate(this.stateService.getUserGmid(),
      this.selectedGlobalScenario.id, this.startYear, this.endYear).subscribe(
      (file: any) => {
        this.excelExportService.exportToExcelFromServer(file, fileName);
      },
      () => {
        this.snackBar.displayError('Error with exporting data.', DISMISS_MSG);
        this.showSpinner = false;
      }, () => {
        this.showSpinner = false;
        this.snackBar.displaySuccess('Successfully retrieved vehicle records. Exporting...', DISMISS_MSG);
      });
  }

  /**
   * Event handler for when a selected Global Scenario is confirmed
   * @param data the data from the event
   */
  onScenarioSelection(data: any) {
    this.selectedGlobalScenario = data.globalScenario;
  }


  /**
   * Gets the year range for the reports
   */
  getYearRange(): void {
    const {yearRange, startYear, endYear} = getDefaultYearRange();
    this.yearRange = yearRange;
    this.startYear = startYear;
    this.endYear = endYear;
  }
}
